// Admin LexiQamus Pages index — row click opens edit in a new tab.
import { Controller } from 'stimulus'

export default class extends Controller {
  rowClick(event) {
    const row     = event.currentTarget
    const editUrl = row.dataset.sitePageEditUrl
    if (!editUrl) return

    const interactiveElements = event.target.closest('.js-site-pages-index-actions, button')
    if (interactiveElements) return

    window.open(editUrl, '_blank', 'noopener,noreferrer')
  }
}
